/* eslint-disable */

const electronicVouchers = [
    {
        codigoSunat: '01',
        descripcion: 'Factura'
    },
    {
        codigoSunat: '03',
        descripcion: 'Boleta de venta'
    },
    {
        codigoSunat: '06',
        descripcion: 'Carta de porte aéreo'
    },
    {
        codigoSunat: '07',
        descripcion: 'Nota de crédito'
    },
    {
        codigoSunat: '08',
        descripcion: 'Nota de débito'
    },
    {
        codigoSunat: '09',
        descripcion: 'Guía de remisión remitente'
    },
    {
        codigoSunat: '12',
        descripcion: 'Ticket de máquina registradora'
    },
    {
        codigoSunat: '13',
        descripcion: 'Documento emitido por bancos, instituciones financieras, crediticias y de seguros que se encuentren bajo el control de la Superintendencia de Banca y Seguros'
    },
    {
        codigoSunat: '14',
        descripcion: 'Recibo servicios públicos'
    },
    {
        codigoSunat: '15',
        descripcion: 'Boletos emitidos por el servicio de transporte terrestre regular urbano de pasajeros y el ferroviario público de pasajeros prestado en vía férrea local'
    },
    {
        codigoSunat: '16',
        descripcion: 'Boleto de viaje emitido por las empresas de transporte público interprovincial de pasajeros'
    },
    {
        codigoSunat: '18',
        descripcion: 'Documentos emitidos por las AFP'
    },
    {
        codigoSunat: '20',
        descripcion: 'Comprobante de retención'
    },
    {
        codigoSunat: '21',
        descripcion: 'Conocimiento de embarque por el servicio de transporte de carga marítima'
    },
    {
        codigoSunat: '24',
        descripcion: 'Certificado de pago de regalías emitidas por PERUPETRO S.A.'
    },
    {
        codigoSunat: '31',
        descripcion: 'Guía de remisión transportista'
    },
    {
        codigoSunat: '37',
        descripcion: 'Documentos que emitan los concesionarios del servicio de revisiones técnicas'
    },
    {
        codigoSunat: '40',
        descripcion: 'Comprobante de Percepción '
    },
    {
        codigoSunat: '41',
        descripcion: 'Comprobante de Percepción – Venta interna ( físico - formato impreso)'
    },
    {
        codigoSunat: '43',
        descripcion: 'Boleto de compañías de aviación transporte aéreo no regular'
    },
    {
        codigoSunat: '45',
        descripcion: 'Documentos emitidos por centros educativos y culturales, universidades, asociaciones y fundaciones'
    },
    {
        codigoSunat: '56',
        descripcion: 'Comprobante de pago SEAE'
    },
    {
        codigoSunat: '71',
        descripcion: 'Guía de remisión remitente complementaria'
    },
    {
        codigoSunat: '72',
        descripcion: 'Guía de remisión transportista complementaria'
    }
]

export default electronicVouchers



// WEBPACK FOOTER //
// ./src/interfaces/electronicVouchers.js